import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import UserTable from './table';
import ModalExample from "./popup";
import ModalExample2 from "../../elements/PopupWindow";
import {config} from "../../../utility/swaggerClient";
import FileItem from "../../elements/FileItem";

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'dashboard.title',
    description: 'Page Header Title',
    defaultMessage: 'Dashboard'
  },
  headerSubTitle: {
    id: 'dashboard.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Download Report or Translated Code'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

// let repos = [];

class Dashboard extends Component {
  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state = {
      showDetail: false,
      showDetailSent: false,
      refreshbtn: true,
      ref: "",
      srcstatus: "",
      reponame:"",
      srclang:"",
      tgtlang:"",
      jobType:"",
      jobStatus:"",
      description:"",
      customer: "",
      stagingrepo: "",
      detailpage: "",
      repos: [],
      organization:""
    };
  }
  setRepo =(r)=>{
    this.setState({repos: r});
  }

  showDetailTrue = () => {
    this.setState({ showDetail: true });
  };
  showDetailFalse = () => {
    this.setState({ showDetail: false, ref: "" });
    messages.headerSubTitle.id = 'dashboard.subtitle';
  };

  showDetailSentTrue = ()=>{
    this.setState({showDetailSent : true});
  }

  selectItem = (value)=>{
    console.log(value);
    this.setState({
      ref : value.referenceId,
      srcstatus : value.sourcestatus,
      reponame: value.reponame,
      srclang: value.srclang,
      tgtlang:value.tgtlang,
      jobType:value.jobType,
      jobStatus: value.jobStatus,
      description: value.description,
      stagingrepo: ""
    });
  }

  nprefresh = ()=>{
    // let cus = this.state.customer;
    window.location.reload();
    // this.props.NPRequestList(this.state.customer)
  }

  NPselectItem = (value)=>{
    console.log(value);
    this.setState({
      ref : value.reference_id,
      srcstatus : value.sourcestatus,
      reponame: value.reponame,
      srclang: value.srclang,
      tgtlang:value.tgtlang,
      jobType:value.job_type,
      jobStatus: value.job_status,
      description: value.description,
      stagingrepo: value.staging_reponame
    });

    this.props.getStagingPrjList(value.job_type,value.reponame,this.state.customer,this.getStagingrepos);
  }


  getStagingrepos = ()=>{
    const repos = [];
    this.props.releasestagingprojectList.map(item => (
        repos.push({value:item, checked: false})
    ));
    console.log(repos);
    this.setState({repos});
  }

  repoCallback = ()=>{
    let temp = "";
    this.state.repos.forEach((r)=>{
      if(r.checked){
        temp += r.value;
        temp += ",";
      }
    })
    if(temp !== ""){
      temp = temp.substring(0, temp.length - 1);
    }
    console.log(temp);

    this.setState({stagingrepo: temp});
  }

  sourceCodedownload = (customerid,reponame)=>{
    console.log(this.state.stagingrepo);
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    };
    fetch(`${config.protocol}://${config.host}/api/user/download/${customerid}/${reponame}`, requestOptions)
      .then(response =>
      {
        console.log(response)
        // if(response.status === 200){
        //   throw new Error("woops");
        // }
        return response.blob()
      })
      .then(data => {
        console.log(data)
        const FileDownload = require("js-file-download");
        FileDownload(data, "Source Code.zip");
      }).catch(err => console.log(err));
  }

  TranslatedCodedownload = (ref,type)=>{
    console.log(this.state.stagingrepo);
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    };
    fetch(`${config.protocol}://${config.host}/api/user/translationcode/${type}/${ref}`, requestOptions)
      .then(response => response.blob())
      .then(data => {
        const FileDownload = require("js-file-download");
        FileDownload(data, "Translated Code.zip");
      });
  }

  reportdownload = (ref,type)=>{
    console.log(this.state.stagingrepo);
    console.log(this.state.stagingrepo === "");
    console.log(type);
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    };
    fetch(`${config.protocol}://${config.host}/api/user/reports/${type}/${ref}`, requestOptions)
      .then(response => response.blob())
      .then(data => {
        const FileDownload = require("js-file-download");
        FileDownload(data, "Report.zip");
      });
  }

  gotoDetail = (type) =>{
    this.setState({showDetail : true, detailpage: type});
    if(type === 'download'){
      if(this.state.jobType === 'Translation') {
        messages.headerSubTitle.id = 'dashboard.download.translate';
      }
      else if(this.state.jobType === 'Assessment' || this.state.jobType === 'FreeAssessment'){
        messages.headerSubTitle.id = 'dashboard.download.analyzer';
      }
    }
    else if(type === 'release'){
      if(this.state.jobType === 'Translation') {
        messages.headerSubTitle.id = 'dashboard.release.translate2';
      }
      else if(this.state.jobType === 'Assessment' || this.state.jobType === 'FreeAssessment'){
        messages.headerSubTitle.id = 'dashboard.release.analyzer2';
      }
    }
  }

  selectCus = (e)=>{
    this.props.customersList.forEach((item)=>{
      if(e.target.value === item["customer_id"]){
        this.setState({customer : e.target.value, organization : item["company_name"]});
      }
    })
    this.props.NPRequestList(e.target.value);
    this.setState({refreshbtn: false})
  }

  confirmation = ()=>{}
  confirmationSubmit = ()=>{
    if(this.props.role.includes('CUSTOMER_ADMIN')){
      const callback = ()=>this.props.RequestList(this.props.username);
      this.props.deletesrccode(this.props.customerid,this.state.reponame,callback);

    }else{
      const callback = ()=> this.props.NPRequestList(this.state.customer);
      this.props.deletesrccode(this.state.customer,this.state.stagingrepo,callback);
    }
  }
  submitRequest = ()=>{
    this.confirmation();
  }
  confirmationText = "Your legacy code will be permanently deleted from our system in 5 business days. Do you want to delete?   <br /><br />"

  componentDidMount(){
    if(this.props.role.includes('PROFESSIONAL_SERVICE') || this.props.role.includes('CUSTOMER_ADMIN')){
      this.props.RequestList(this.props.username);
    }else{
      this.props.getCustomers();
    }
  }

  render() {
    if(this.props.role.includes('TRANSLATION_LEAD') || this.props.role.includes('DATA_ENGINEER')){
      return (
        <div className="preview page">
          <Helmet>
            <title>
              {this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT
            </title>
          </Helmet>
          <Header
            title={this.props.intl.formatMessage(messages.headerTitle)}
            subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
            icon="preview"
            locale={this.props.locale}
            status = {this.props.status}
          />
          <ModalExample2
            hasTitle
            confirmation_dashboard
            infoText="Confirmation"
            className="modal_md"
            setClick={click => this.confirmation = click}
            confirmationSub = {this.confirmationSubmit}
            content={this.confirmationText}/>

          <div className="main">
            {this.state.showDetail &&(
              <div
                className="panel"
                style={{
                  width: '60%',
                  padding: '40px',
                  boxSizing: 'content-box',
                  // marginTop: '15px',
                  display: 'block',
                  alignContent: 'center',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              >
                {this.state.showDetailSent &&(
                  <div>
                    <label
                      style={{
                        width: '90%',
                        fontSize: '16px',
                        textTransform: 'none',
                        lineHeight: '150%'
                      }}
                    >
                      You have successfully released
                      {this.state.jobType === 'Translation' && ' the translated target code for the commercial code translation '}
                      {this.state.jobType === 'Assessment' && ' the analyzer report '}
                      for:
                      <br /><br />
                      Customer name: {' '}
                      {/*{this.props.customersList.filter(item => this.state.customer === item["customer_id"])*/}
                      {/*.map(item => (item["company_name"]))}*/}
                      {this.state.organization}
                      <br /><br />
                      Project name:{' '} {this.state.reponame}
                      <br /><br />
                      Staging project:
                      {this.state.stagingrepo.split(',').map((stag,index) => (
                        <p key={index} style={{paddingLeft:'15px'}}>{stag}</p>
                        ))}
                      <br /><br />

                      A notification email will be sent to the customer.
                    </label>
                    <br />
                    &nbsp;
                    <br />
                    &nbsp;
                    <div className="button-container" style={{ textAlign: 'center' }}>
                      <button
                        className="button"
                        styel={{ padding: 20 }}
                        type="button"
                        onClick={() => window.location.reload()}
                      >
                        <FormattedMessage id="nav.ok" defaultMessage="OK" />
                      </button>
                    </div>
                  </div>
                )}

                {!this.state.showDetailSent &&(
                  <LocalForm className="form">
                    <div
                      style={{
                        marginLeft: '3%'
                      }}
                    >

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="onboard.organization"
                          />
                        </label>

                        <Control.text
                          model=".customer"
                          value={this.state.organization}
                          disabled
                        >
                        </Control.text>

                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="source.code.repository.name"
                          />
                        </label>

                        <Control.text
                          model=".reponame"
                          defaultValue={this.state.reponame}
                          disabled
                        >
                        </Control.text>
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="assessment.stagingname"
                          />
                        </label>

                        <Control.text
                          model=".stagingrepo"
                          value={this.state.stagingrepo}
                          disabled
                        >
                        </Control.text>

                        {this.state.detailpage === 'release' &&(
                          <ModalExample hasTitle
                                        info
                                        infoText="Select source code staging project names:"
                                        className="modal_md"
                                        repos = {this.state.repos}
                                        changeStagingprj ={this.repoCallback}
                                        buttonLabel = "MODIFY"
                                        setRepo = {this.setRepo}
                          >
                          </ModalExample>
                        )}

                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="dashboard.referenceid"
                            defaultMessage="Reference ID: "
                          />
                        </label>

                        <Control.text
                          model=".customer"
                          defaultValue={this.state.ref}
                          disabled
                        >
                        </Control.text>

                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="projects.project.source-languagee"
                            defaultMessage="Source Language: "
                          />
                        </label>

                        <Control.text
                          model=".srclang"
                          value={this.state.srclang}
                          disabled
                        >
                        </Control.text>

                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="projects.project.target-language"
                            defaultMessage="Target Language: "
                          />
                        </label>

                        <Control.text
                          model=".tgtlang"
                          value={this.state.tgtlang}
                          disabled
                        >
                        </Control.text>
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="comments.name"
                            defaultMessage="Description"
                          />
                        </label>

                        <Control.text
                          model=".description"
                          value={this.state.description}
                          disabled
                        />
                      </fieldset>

                      <div
                        className="button-container"
                        style={{ textAlign: 'center' }}
                      >
                        <button
                          className="button"
                          type="button"
                          style={{ marginRight: '40px' }}
                          onClick={this.showDetailFalse}
                        >
                          <FormattedMessage
                            id="run-assessment.back.button.name"
                            defaultMessage="Back"
                          />
                        </button>

                        {this.state.detailpage === 'download' && this.state.jobType === 'Translation' && (
                          <button
                            className="button"
                            type="button"
                            onClick={() =>
                              this.state.stagingrepo === "" ?
                              this.TranslatedCodedownload(this.state.ref,'translation') :
                              this.TranslatedCodedownload(this.state.ref,'internal_translation')
                            }
                          >
                            <FormattedMessage
                              id="dashboard.download.translate"
                              defaultMessage="DOWNLOAD TRANSLATED CODE"
                            />
                          </button>
                        )}

                        {this.state.detailpage === 'release' && this.state.jobType === 'Translation' && (
                          <button
                            className="button"
                            type="button"
                            onClick={() => this.props.approvetranslation(
                              this.props.username,
                              this.state.reponame,
                              this.state.srclang,
                              this.state.tgtlang,
                              this.state.description,
                              this.state.jobType,
                              this.state.stagingrepo,
                              this.state.customer,
                              this.state.ref,
                              this.showDetailSentTrue
                            )}
                            disabled={this.state.stagingrepo === ""}
                          >
                            <FormattedMessage
                              id="dashboard.release.translate"
                              defaultMessage="DOWNLOAD TRANSLATED CODE"
                            />
                          </button>
                        )}

                        {this.state.detailpage === 'release' && (this.state.jobType === 'Assessment' || this.state.jobType === 'FreeAssessment') && (
                          <button
                            className="button"
                            type="button"
                            onClick={() => this.props.approveassessment(
                              this.props.username,
                              this.state.reponame,
                              this.state.srclang,
                              this.state.tgtlang,
                              this.state.description,
                              this.state.jobType,
                              this.state.stagingrepo,
                              this.state.customer,
                              this.state.ref,
                              this.showDetailSentTrue
                            )}
                            disabled={this.state.stagingrepo === ""}
                          >
                            <FormattedMessage
                              id="dashboard.release.analyzer"
                              defaultMessage="DOWNLOAD TRANSLATED CODE"
                            />
                          </button>
                        )}

                        {this.state.detailpage === 'download' && (this.state.jobType === 'Assessment' || this.state.jobType === 'FreeAssessment') && (
                          <button
                            className="button"
                            type="button"
                            onClick={() =>
                              this.state.stagingrepo === "" ?
                              this.reportdownload(this.state.ref,'assessment') :
                              this.reportdownload(this.state.ref,'internal_assessment')}
                          >
                            <FormattedMessage
                              id="dashboard.download.analyzer"
                              defaultMessage="DOWNLOAD TRANSLATED CODE"
                            />
                          </button>
                        )}


                      </div>
                    </div>
                  </LocalForm>
                )}

              </div>

            )}

            {!this.state.showDetail && (
              <div
                className="panel"
                style={{
                  width: '80%',
                  boxSizing: 'content-box',
                  // marginTop: '15px',
                  display: 'block',
                  alignContent: 'center',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              >
                <div className="form">
                  <fieldset style={{padding: '20px', width: "auto", float:"none"}}>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="dashboard.customer"
                        defaultMessage="Organization Name: "
                      />
                    </label>

                    <Control.select
                      model=".customer"
                      autoFocus
                      required
                      value={this.state.customer}
                      onChange={this.selectCus}
                    >
                      {this.state.customer === "" && <option value="">Please select organization name</option>}
                      {this.props.customersList.map(item => (
                        <option key={item["customer_id"]} value={item["customer_id"]}>
                          {item["company_name"]}
                        </option>
                      ))}
                    </Control.select>

                  </fieldset>

                  {this.state.customer && (
                    <UserTable data={this.props.transactions} selectItem={this.NPselectItem} username={this.props.username} userrole={this.props.role}/>
                  )}

                </div>

               <br />
                <div
                  className="button-container"
                  style={{ textAlign: 'center' }}
                >
                  <button
                    className="button"
                    style={{ marginRight: '40px' }}
                    type="button"
                    onClick={() => this.props.NPRequestList(this.state.customer)}
                    disabled={this.state.refreshbtn}
                    // onClick={() => this.nprefresh()}
                  >
                    REFRESH
                  </button>
                  <button
                    className="button"
                    style={{ marginRight: '40px' }}
                    type="button"
                    onClick={() => this.props.clickBackHandler()}
                  >
                    <FormattedMessage
                      id="run-assessment.back.button.name"
                      defaultMessage="Back"
                    />
                  </button>
                  <button
                    className="button"
                    style={{ marginRight: '40px' }}
                    type="button"
                    onClick={() => this.gotoDetail('download')}
                    disabled={this.state.ref === '' || !(this.state.jobStatus === 'Success' || this.state.jobStatus === 'Failure')}
                  >
                    {this.state.jobType === 'Translation' && (
                      <FormattedMessage
                      id="dashboard.download.translate"
                      defaultMessage="Download"
                      />
                      )}
                    {(this.state.jobType === 'Assessment' || this.state.jobType === 'FreeAssessment') && (
                      <FormattedMessage
                        id="dashboard.download.analyzer"
                        defaultMessage="Download"
                      />
                    )}
                    {this.state.jobType !== 'Assessment' && this.state.jobType !== 'Translation' && this.state.jobType !== 'FreeAssessment' &&(
                      <FormattedMessage
                        id="download.button.name"
                        defaultMessage="Download"
                      />
                    )}
                  </button>
                  <button
                    className="button"
                    style={{ marginRight: '40px' }}
                    type="button"
                    onClick={() => this.state.stagingrepo === "" ?
                      this.sourceCodedownload(this.state.customer, this.state.reponame) :
                      this.sourceCodedownload(this.state.customer, this.state.stagingrepo)

                    }
                    disabled={this.state.ref === '' || this.state.srcstatus === 'DELETED' || this.state.srcstatus === 'PURGED'}
                  >
                    <FormattedMessage
                      id="dashboard.download.srccode"
                      defaultMessage="Download"
                    />
                  </button>
                  {this.props.role.includes('TRANSLATION_LEAD') && (
                    <div style={{display: 'inline-block'}}>
                      <button
                        className="button"
                        style={{ marginRight: '40px' }}
                        type="button"
                        disabled={this.state.ref === '' || this.state.srcstatus === 'DELETED' || this.state.srcstatus === 'PURGED' ||  this.state.jobStatus === 'In Progress' || this.state.stagingrepo ==''}
                        onClick={this.submitRequest}
                      >
                        <FormattedMessage
                          id="dashboard.download.delete"
                          defaultMessage="Release"
                        />
                      </button>
                      <button
                        className="button"
                        style={{ marginRight: '40px' }}
                        type="button"
                        onClick={() => this.gotoDetail('release')}
                        disabled={this.state.ref === '' || this.state.srcstatus === 'DELETED' || this.state.srcstatus === 'PURGED' ||  this.state.stagingrepo !== '' || this.state.jobStatus !== 'In Progress'}
                      >
                        <FormattedMessage
                          id="dashboard.release"
                          defaultMessage="Release"
                        />
                      </button>
                    </div>
                  )}
                </div>
                <br/>
                <br/>
              </div>
            )}
          </div>
          <Footer />
        </div>
      );
    }else{
      return (
        <div className="preview page">
          <Helmet>
            <title>
              {this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT
            </title>
          </Helmet>
          <Header
            title={this.props.intl.formatMessage(messages.headerTitle)}
            subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
            icon="preview"
            locale={this.props.locale}
            status = {this.props.status}
          />
          <ModalExample2
            hasTitle
            confirmation_dashboard
            infoText="Confirmation"
            className="modal_md"
            setClick={click => this.confirmation = click}
            confirmationSub = {this.confirmationSubmit}
            content={this.confirmationText}/>

          <div className="main">
            {this.state.showDetail &&(
              <div
                className="panel"
                style={{
                  width: '60%',
                  padding: '40px',
                  boxSizing: 'content-box',
                  marginTop: '15px',
                  display: 'block',
                  alignContent: 'center',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              >
                {this.state.showDetailSent &&(
                  <div>
                    <label
                      style={{
                        width: '90%',
                        fontSize: '16px',
                        textTransform: 'none',
                        lineHeight: '150%'
                      }}
                    >
                      You have successfully released the translated target code for the commercial code translation for :
                      <br /><br />
                      Customer name:
                      Project name: for the project XXXXXXX
                      <br /><br />

                      A notification email will be sent to the customer .
                    </label>
                    <br />
                    &nbsp;
                    <br />
                    &nbsp;
                    <div className="button-container" style={{ textAlign: 'center' }}>
                      <button
                        className="button"
                        styel={{ padding: 20 }}
                        type="button"
                        onClick={() => window.location.reload()}
                      >
                        <FormattedMessage id="nav.ok" defaultMessage="OK" />
                      </button>
                    </div>
                  </div>
                )}

                {!this.state.showDetailSent &&(
                  <LocalForm
                    className="form"
                    // onSubmit={}
                  >
                    <div
                      style={{
                        marginLeft: '3%'
                      }}
                    >
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="dashboard.referenceid"
                            defaultMessage="Reference ID: "
                          />
                        </label>

                        <Control.text
                          model=".customer"
                          defaultValue={this.state.ref}
                          disabled
                        >
                        </Control.text>

                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="source.code.repository.name"
                            defaultMessage="Source Code Repository Name: "
                          />
                        </label>

                        <Control.text
                          model=".reponame"
                          defaultValue={this.state.reponame}
                          disabled
                        >
                        </Control.text>
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="projects.project.source-languagee"
                            defaultMessage="Source Language: "
                          />
                        </label>

                        <Control.text
                          model=".srclang"
                          value={this.state.srclang}
                          disabled
                        >
                        </Control.text>

                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="projects.project.target-language"
                            defaultMessage="Target Language: "
                          />
                        </label>

                        <Control.text
                          model=".tgtlang"
                          value={this.state.tgtlang}
                          disabled
                        >
                        </Control.text>
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="comments.name"
                            defaultMessage="Description"
                          />
                        </label>

                        <Control.text
                          model=".description"
                          value={this.state.description}
                          disabled
                        />
                      </fieldset>

                      <div
                        className="button-container"
                        style={{ textAlign: 'center' }}
                      >
                        <button
                          className="button"
                          type="button"
                          style={{ marginRight: '40px' }}
                          onClick={this.showDetailFalse}
                        >
                          <FormattedMessage
                            id="run-assessment.back.button.name"
                            defaultMessage="Back"
                          />
                        </button>

                        {this.state.detailpage === 'download' && (this.state.jobType === 'Assessment' || this.state.jobType === 'FreeAssessment') && (
                          <button
                            className="button"
                            type="button"
                            onClick={() => this.reportdownload(this.state.ref,'assessment')
                            }
                          >
                            <FormattedMessage
                              id="dashboard.download.analyzer"
                              defaultMessage="DOWNLOAD TRANSLATED CODE"
                            />
                          </button>
                        )}

                        {this.state.detailpage === 'download' && this.state.jobType === 'Translation' && (
                          <button
                            className="button"
                            type="button"
                            onClick={() => this.TranslatedCodedownload(this.state.ref,'translation')}
                          >
                            <FormattedMessage
                              id="dashboard.download.translate"
                              defaultMessage="DOWNLOAD TRANSLATED CODE"
                            />
                          </button>
                        )}

                      </div>
                    </div>
                  </LocalForm>
                )}

              </div>

            )}

            {!this.state.showDetail && (
              <div
                className="panel"
                style={{
                  width: '80%',
                  boxSizing: 'content-box',
                  marginTop: '15px',
                  display: 'block',
                  alignContent: 'center',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }}
              >
                <UserTable data={this.props.transactions} selectItem={this.selectItem} username={this.props.username} userrole={this.props.role}/>

                <br/>
                <br/>
                <div
                  className="button-container"
                  style={{ textAlign: 'center' }}
                >
                  <button
                    className="button"
                    style={{ marginRight: '40px' }}
                    type="button"
                    // onClick={() => this.props.RequestList(this.props.username)}
                    onClick={() => window.location.reload()}
                  >
                    REFRESH
                  </button>
                  <button
                    className="button"
                    style={{ marginRight: '40px' }}
                    type="button"
                    onClick={() => this.props.clickBackHandler()}
                  >
                    <FormattedMessage
                      id="run-assessment.back.button.name"
                      defaultMessage="Back"
                    />
                  </button>
                  <button
                    className="button"
                    style={{ marginRight: '40px' }}
                    type="button"
                    onClick={() => this.gotoDetail('download')}
                    disabled={this.state.ref === '' || !(this.state.jobStatus === 'Success' || this.state.jobStatus === 'Failure')}
                  >
                    {this.state.jobType === 'Translation' && (
                      <FormattedMessage
                        id="dashboard.download.translate"
                        defaultMessage="Download"
                      />
                    )}
                    {(this.state.jobType === 'Assessment' || this.state.jobType === 'FreeAssessment') && (
                      <FormattedMessage
                        id="dashboard.download.analyzer"
                        defaultMessage="Download"
                      />
                    )}
                    {this.state.jobType !== 'Assessment' && this.state.jobType !== 'Translation' && this.state.jobType !== 'FreeAssessment' &&(
                      <FormattedMessage
                        id="download.button.name"
                        defaultMessage="Download"
                      />
                    )}
                  </button>
                  <button
                    className="button"
                    style={{ marginRight: '40px' }}
                    type="button"
                    onClick={() => this.sourceCodedownload(this.props.customerid, this.state.reponame)}
                    disabled={this.state.ref === '' || this.state.srcstatus === 'DELETED' || this.state.srcstatus === 'PURGED'}
                  >
                    <FormattedMessage
                      id="dashboard.download.srccode"
                      defaultMessage="Download"
                    />
                  </button>
                  { this.props.role.includes('CUSTOMER_ADMIN') &&(
                    <button
                      className="button"
                      style={{ marginRight: '40px' }}
                      type="button"
                      onClick={this.submitRequest}
                      // disabled={this.state.ref === '' ||  (this.state.jobStatus !== 'Success' && this.state.jobStatus !== 'Failure')}
                      disabled={this.state.ref === '' || this.state.srcstatus === 'DELETED' || this.state.srcstatus === 'PURGED' ||  this.state.jobStatus === 'In Progress'}
                    >
                      <FormattedMessage
                        id="dashboard.download.delete"
                        defaultMessage="Release"
                      />
                    </button>
                  )}
                </div>
                <br/>
                <br/>
              </div>
            )}
          </div>
          <Footer />
        </div>
      );
    }
  }
}

Dashboard.propTypes = {
  username: PropTypes.string,
  usersList: PropTypes.array
};

export default injectIntl(Dashboard);



// WEBPACK FOOTER //
// ./src/components/views/Dashboard/index.js